import { t } from '../i18n/t';
import { stickerName, type StickerSlug } from './stickers.ts';
// Explicit `index.ts`: a bare `./stickers` resolves to the sibling
// `stickers.ts` (the slug list), a file outranking a directory.
import { STICKER_ART } from './stickers/index.ts';

/**
 * A sticker, named for a screen reader only when `named`: beside text that
 * already says what it is (the celebration line, the Progress card) the name
 * would be read twice.
 */
export function Sticker({
  slug,
  className,
  named = false,
}: {
  slug: StickerSlug;
  className?: string;
  named?: boolean;
}) {
  const Art = STICKER_ART[slug];
  if (!named) return <Art className={className} />;
  return (
    <span role="img" aria-label={t(stickerName(slug))} className={`block ${className ?? ''}`}>
      <Art className="size-full" />
    </span>
  );
}
